import React from "react";
import { Carousel } from "antd";

class DigitalCoinWithdrawLesson extends React.Component { // copy from ./index.js then modify
    constructor(props) {
        super(props);
        this.state = {
            generalIndex: 0,
        };
    }

    componentDidMount() {
        document.addEventListener(
            "keydown",
            function (event) {
                event.stopPropagation();
                console.log(event);
            },
            true
        );
    }

    handleChange = (key) => {
        console.log(key);
    };

    generalPrevClick = () => {
        this.refs.GeneralSlider.slick.slickPrev();
    };

    generalNextClick = () => {
        console.log("checkpoint", this.refs);
        this.refs.GeneralSlider.slick.slickNext();
    };

    generalOnChange = (n) => {
        console.log(n);
        this.setState({ generalIndex: n });
    };

    render() {
        const digitalLessons = [
            {
                index: 0,
                id: "digital-ls-1",
                content: () => <></>,
            },
            {
                index: 1,
                id: "digital-ls-2",
                content: () => <></>,
            },
            {
                index: 2,
                id: "digital-ls-3",
                content: () => <></>,
            },
            {
                index: 3,
                id: "digital-ls-4",
                content: () => <></>,
            },
        ];

        return (
            <React.Fragment>
                <div style={{ textAlign: "center", padding:'24px 0 14px' }} className="digital-coin-withdraw-lesson">
                    <Carousel
                        key={1}
                        ref="GeneralSlider"
                        className="custom-Carousel"
                        afterChange={(current) => {
                            this.generalOnChange(current);
                        }}
                    >
                        {digitalLessons.map((item, index) => (
                            <div
                                key={item.id}
                                className={`crypto-lesson-wrap ${item.id}`}
                            >
                                <div className="crypto-lesson-body">
                                    {item.content()}
                                </div>
                            </div>
                        ))}
                    </Carousel>
                    {this.state.generalIndex > 0 && (
                        <div
                            className="left-next"
                            onClick={this.generalPrevClick}
                        >
                            <img
                                className="arrowLeftRight"
                                src={
                                    "/cn/img/withdrawlesson/icon-left.svg"
                                }
                                alt="left"
                            />
                        </div>
                    )}
                    {this.state.generalIndex !=
                        digitalLessons.length - 1 && (
                        <div
                            className="right-next"
                            onClick={this.generalNextClick}
                        >
                            <img
                                className="arrowLeftRight"
                                src={
                                    "/cn/img/withdrawlesson/icon-right.svg"
                                }
                                alt="right"
                            />
                        </div>
                    )}
                </div>
            </React.Fragment>
        );
    }
}
export default DigitalCoinWithdrawLesson;
